import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';

declare var analytics: any;
declare var window: any;
declare var Intercom: any;
declare const require: any;
var CryptoJS = require('crypto-js');

@Injectable()
export class AnalyticsService {
  constructor() {}
  segmentPage(page) {
    let user = JSON.parse(localStorage.getItem('CURRENT_USER'));
    if (user) {
      analytics.page('Customer Landed', {
        userId: user._id,
        pageName: page
      });
      if (page == '/main/dashboard') {
        analytics.identify(user._id, {
          pageName: page,
          name: user.fullname,
          email: user.email,
          //birthday: '{{ Auth::user()->dob }}',
          gender: user.gender,
          city: user.city,
          state: user.state,
          zip: user.zipCode,
          phone: user.phone
          //address: '{{ Auth::user()->address }}'
        });
      }
    } else {
      let extraProperties: any = {};
      extraProperties.pageName = page;
      analytics.page('Visitor Landed', extraProperties);
    }
  }
  segmentTrackPhone(userid, phone) {
    analytics.track('Phone Entered', {
      phone: phone,
      userId: userid
    });
  }
  segmentTrackCard(userid) {
    let user = JSON.parse(localStorage.getItem('CURRENT_USER'));
    analytics.track('Credit Card Updated', {
      userId: userid
    });
  }
  segmentTrackProfile(userid) {
    analytics.track('Profile Info Updated', {
      userId: userid
    });
  }
  segmentTrackBill(userid, billType) {
    analytics.track('Bill Info Updated', {
      userId: userid,
      billType: billType
    });
  }
  segmentTrackFirstBill(userid, billType, actionTook) {
    analytics.track('Upload at least one bill', {
      userId: userid,
      billType: billType,
      actionTook: actionTook
    });
  }
  segmentTrackCallInitiated(userid) {
    analytics.track('Call Initiated', {
      userId: userid
    });
  }
  segmentChatIntiated(page) {
    let user = JSON.parse(localStorage.getItem('CURRENT_USER'));
    if (user && Intercom) {
      Intercom('onShow', function() {
        analytics.track('Chat Initiated', {
          pathName: window.location.pathname,
          userId: user._id
        });
      });
    }
  }
  intercomeChat() {
    let user = JSON.parse(localStorage.getItem('CURRENT_USER'));
    let user_hash = JSON.parse(localStorage.getItem('USER_HASH'));
    if (user && user_hash) {
      //let user_id = user.id.toString();;
      //let hash = CryptoJS.HmacSHA256(user_id, "5jprZalVWwO1Bf9I6fPJHIFTteEsRzP8LWpxvb1B");
      //let hashInHex = CryptoJS.enc.Hex.stringify(hash);
      let time = new Date(user.created_at);
      window.intercomSettings = {
        name: user.fullname,
        email: user.email,
        user_id: user._id,
        app_id: 'q6ftayvs',
        created_at: time.getTime(),
        user_hash: user_hash,
        custom_launcher_selector: '.lets_chat'
      };
      window.Intercom('update');
    } else {
      window.intercomSettings = {
        app_id: 'q6ftayvs'
      };
      window.Intercom('update');
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/common/analytics.service.ts